export const getNichos = [
  { value: 'NT1', label: 'Companhia de Capital Aberto' },
  { value: 'NT2', label: 'Companhia de Capital Fechado' },
  { value: 'NT3', label: 'Associação' },
  { value: 'NT4', label: 'Cooperativa' },
  { value: 'NT5', label: 'Credores' },
  { value: 'NT6', label: 'Fundo de Investimentos' },
  { value: 'NT7', label: 'Condomínios' },
  { value: 'NT8', label: 'Outros' },
];

export function getNichoType(
  statusType: 'NT1' | 'NT2' | 'NT3' | 'NT4' | 'NT5' | 'NT6' | 'NT7' | undefined,
) {
  switch (statusType) {
    case 'NT1':
      return 'Companhia de Capital Aberto';
    case 'NT2':
      return 'Companhia de Capital Fechado';
    case 'NT3':
      return 'Associação';
    case 'NT4':
      return 'Cooperativa';
    case 'NT5':
      return 'Credores';
    case 'NT6':
      return 'Fundo de Investimentos';
    case 'NT7':
      return 'Condomínios';
    default:
      return 'Outros';
  }
}

export const formattCurrency = (value: number) => {
  if (!value) {
    return 'R$ 0,00';
  }

  const currency = value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  return currency;
};
